import history from './history.js'

export const redirect = (path, origin) => history.push(path, { origin })
